<!-- @veltra/icons generated sha256:f17cffff01bac6ba gen:8 source:src/svg/normal/caret-right.svg -->
<script setup lang="ts">
defineOptions({ name: 'CaretRight' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M11.81 7.65 4.65 1.48c-.27-.23-.66-.02-.66.35v12.34c0 .37.39.58.66.35l7.16-6.17c.2-.18.2-.52 0-.7"
    />
  </svg>
</template>
